module.exports = __webpack_public_path__ + "components/bookings-online-payment-method/static/amex-6c82910831a427b4fdc7c61fcde7d1cb.svg";